module.exports = __webpack_public_path__ + "img/Mode_Selector_Turkish.bdb90d29.png";